export const DEFAULT_VIDEO_CONSTRAINTS: MediaStreamConstraints['video'] = {
  width: 1280,
  height: 720,
  frameRate: 24,
};

// The Twilio identity video-api gives the staff side of a call. The host leaving ends the call (video-api
// completes the room); the guest may leave and rejoin while the host is present.
export const HOST_IDENTITY = 'host';

// Twilio disconnect error codes that matter here.
export const ROOM_COMPLETED_ERROR = 53118; // the host ended the call: the link is dead
export const DUPLICATE_IDENTITY_ERROR = 53205; // the same link was opened on another device
